import Productos from "ab-products";

const ProductRows = ({ category, classname, i18n }) => {
  let rowArray = [];
  var i,
    j,
    temporary,
    chunk = 3;
  for (i = 0, j = category?.products?.nodes?.length; i < j; i += chunk) {
    temporary = category?.products?.nodes.slice(i, i + chunk);
    rowArray.push(temporary);
  }
  // console.log("ProductRows", category, rowArray);
  return rowArray.map((itm, index) => (
    <Productos
      className={`three ${
        classname
          ? index % 2 == 0
            ? ""
            : classname
          : index % 2 == 0
          ? classname
          : ""
      }`}
      products={itm?.map((itm) => ({
        src: itm?.image?.mediaItemUrl,
        name: itm.name,
        href: `/tienda/${itm.slug}`,
        price: itm.price,
        databaseId: itm.databaseId,
        location: category.name,
      }))}
      i18n={i18n}
    />
  ));
};

export default ProductRows;
